import { ApiErrorCodes, ClientError } from '@tribeplatform/gql-client'

export const isNotFound = (error: ClientError) => {
  if (!error) return false
  return error?.response?.errors?.some(
    error => String(error.code) === String(ApiErrorCodes.RESOURCE_NOT_FOUND),
  )
}

export const isForbidden = (error: ClientError) => {
  if (!error) return false
  return error?.response?.errors?.some(
    error => String(error.code) === String(ApiErrorCodes.PERMISSION_ERROR),
  )
}
